import React from 'react';

const LogoutIcon = ({ fillColor = '#9B9EA3' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
        <path stroke={fillColor} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6.75 15.75h-3c-.398 0-.78-.158-1.06-.44-.282-.28-.44-.662-.44-1.06V3.75c0-.398.158-.78.44-1.06.28-.282.662-.44 1.06-.44h3M12 12.75L15.75 9 12 5.25M15.75 9h-9"/>
    </svg>
)

export default LogoutIcon;
